import styled from 'styled-components'
import Icon from './Icon'

const SortIcon = styled(Icon).attrs({
  type: 'sort',
})``

export default SortIcon
